import React from "react";
import { DatePicker, TextSchema } from "../InputSchema";

const CertificateSchemaInput = ({
  schemaProps,
  handleChangeFields,
  requiredFields,
  handleDatePicker,
}) => {
  return (
    <form>
      <div className="row m-0">
        {schemaProps &&
          Object.entries(schemaProps).map(([key, value]) => {
            if (key.endsWith("_date")) {
              return (
                <div className="col-md-6" key={key}>
                  <DatePicker
                    selected={value}
                    onChange={(value, ev) => {
                      handleDatePicker(key, value, ev);
                    }}
                    name={key}
                    label={key}
                    required={requiredFields.includes(key)}
                  />
                </div>
              );
            } else {
              return (
                <div className="col-md-6" key={key}>
                  <TextSchema
                    label={key}
                    textValue={value}
                    name={key}
                    onTextInputChange={handleChangeFields}
                    placeholderValue={"Enter " + key}
                    required={requiredFields.includes(key)}
                  />
                </div>
              );
            }
          })}
      </div>
    </form>
  );
};

export default CertificateSchemaInput;
